export namespace AppEvents {
	export const NEW_ITEM_ADDED: string = 'NEW_ITEM_ADDED';
	export const ADD_NEW_ITEM: string = 'ADD_NEW_ITEM';
	export const STATUS_MESSAGE: string = "STATUS_MESSAGE";
	export const ITEM_NAME_CHANGED: string = 'ITEM_NAME_CHANGED';
	export const SELECTED_ITEM_CHANGED: string = 'SELECTED_ITEM_CHANGED';
	export const ITEM_MOVED: string = "ITEM_MOVED";
	export const ITEM_DELETED: string = "ITEM_DELETED";
	export const CURRENT_ITEM_CHANGED: string = "CURRENT_ITEM_CHANGED";
	export const SELECT_ROOT: string = "SELECT_ROOT";
	export const CHILDREN_CHANGED: string = "CHILDREN_CHANGED";
	export const SHOW_TOP_LEVEL_LIST_CONTEXT_MENU: string = "SHOW_TOP_LEVEL_LIST_CONTEXT_MENU";
	export const DIRECTORY_CHANGED: string = "DIRECTORY_CHANGED";
	export const DIRECTORY_LIST_CHANGED: string = "DIRECTORY_LIST_CHANGED";
	export const AUTHENTICATION_CHANGE: string = "authentication-change";//From Aurelia Auth. DO NOT CHANGE TO UPPERCASE.
	export const EDIT_MODE_CHANGED: string = "EDIT_MODE_CHANGED";
	export const NOTIFICATION_COUNT_CHANGED: string = "NOTIFICATION_COUNT_CHANGED";
	export const REFRESH_EXPLORER: string = "REFRESH_EXPLORER";
	export const DIRECTORY_ADDED: string = "DIRECTORY_ADDED";
	export const CHANGE_DIRECTORY: string = "CHANGE_DIRECTORY";
	export const DRAG_ITEM_START: string = "DRAG_ITEM_START";
	export const DRAG_ITEM_END: string = "DRAG_ITEM_END";
	export const EXPLORER_REFRESHED: string = "EXPLORER_REFRESHED";
	export const ToggleIsBusyVisiblity: string = "ToggleIsBusyVisiblity";
	export const MetadataAcquired: string = "MetadataAcquired";
	export const ShowHelpItem: string = "ShowHelpItem";
	export const HideHelpSettingChanged: string = "HideHelpSettingChanged";
}

//export class Events {
//    public static readonly NEW_ITEM_ADDED: string = 'NEW_ITEM_ADDED';
//}